import InputCus from "../../Component/InputCus/Text/InputCus";
import { useEffect, useState } from "react";
import {
  CompanyCreateWarehouse,
  CompanyFilterWarehouse,
  CompanyUpdateWarehouse,
} from "../../Api/Services";
import { useNavigate, useParams } from "react-router-dom";
import { toast } from "react-toastify";
import Select from "../../Component/InputCus/Select/Select";

function WarehouseAE() {
  const [isLoading, setLoading] = useState(true);
  const [form, setForm] = useState({});

  const navigate = useNavigate();

  let { id } = useParams();
  const start = async () => {
    try {
      if (id) {
        const CompanyFilterWarehouseData = await CompanyFilterWarehouse({
          id: id,
        });
        if (
          CompanyFilterWarehouseData.status &&
          CompanyFilterWarehouseData.status === 200
        ) {
          setForm(CompanyFilterWarehouseData.data.data.data[0]);
        }
      }
    } catch (error) {
      console.error("Error during login:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    start();
  }, []);

  const AddUpdate = async () => {
    let validation = true;
    if (form.name === "") {
      toast.error("نام را وارد نمایید ");
      validation = false;
    }
    if (form.type === "") {
      toast.error("نوع را وارد نمایید ");
      validation = false;
    }
    if (validation) {
      setLoading(true);
      try {
        if (id) {
          const CompanyUpdateWarehouseData = await CompanyUpdateWarehouse(form);
          if (
            CompanyUpdateWarehouseData.status &&
            CompanyUpdateWarehouseData.status === 200
          ) {
            toast.success("بروزرسانی با موفقیت انجام شد");
            navigate("/Panel/Warehouses");
          }
        } else {
          const CompanyCreateWarehouseData = await CompanyCreateWarehouse(form);
          if (
            CompanyCreateWarehouseData.status &&
            CompanyCreateWarehouseData.status === 200
          ) {
            toast.success("افزودن  با موفقیت انجام شد");
            navigate("/Panel/Warehouses");
          }
        }
      } catch (error) {
        console.error("Error during login:", error);
      } finally {
        setLoading(false);
      }
    }
  };

  const handleChangeSearch = (e) => {
    const newForm = { ...form };
    newForm[e.target.id] = e.target.value;
    setForm(newForm);
  };

  return (
    <div>
      {isLoading && (
        <div className="d-flex justify-content-center align-items-center">
          <div className="lds-facebook">
            <div />
            <div />
            <div />
          </div>
        </div>
      )}
      <div className={isLoading ? "startLoading" : "stateLoading"}>
        <div className="w-100 d-flex justify-content-between align-items-start p-5">
          <div className="d-flex justify-content-start align-items-center flex-column element w-100 p-5">
            <div className="d-flex justify-content-start align-items-center flex-wrap  ">
              <InputCus
                type="text"
                name="name"
                id="name"
                text="نام"
                className="m-2"
                value={form.name || ""}
                onChange={handleChangeSearch}
              />
              <InputCus
                type="text"
                name="type"
                id="type"
                className="m-2"
                text="نوع"
                value={form.type || ""}
                onChange={handleChangeSearch}
              />
            </div>
            <div className="d-flex justify-content-start align-items-center w-100 m-5">
              <button onClick={AddUpdate} className="butAU">
                {id ? "ویرایش" : "افزودن"}{" "}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default WarehouseAE;
